import React from 'react'

export default function HomeCalucuator() {
  return (
    <section className="calculator-area-2">
    <div className="container">
      <div className="section-title">
        <span className="short-title-2">Loan calculator</span>
        <h1 className="wow fadeInUp text-white">
          Calculate and confirm your loans
        </h1>
      </div>
      <div className="calculator-widget-2 mt-50">
        <div className="row  gy-lg-0 gy-3">
          <div className="col-lg-7">
            <div
              className="single-calculator-widget wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <h4>Loan Calculator</h4>
              <div className="range-label mt-40">Loan Term</div>
              <nav>
                <div
                  className="nav nav-tabs loan-type-select"
                  id="nav-tab"
                  role="tablist"
                >
                  <button
                    className="nav-link active"
                    id="yearTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#yearTab"
                    type="button"
                    role="tab"
                    aria-controls="yearTab"
                    aria-selected="false"
                  >
                    Home Loan
                  </button>
                  <button
                    className="nav-link "
                    id="monthTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#monthTab"
                    type="button"
                    role="tab"
                    aria-controls="monthTab"
                    aria-selected="false"
                  >
                   Personal Loan
                  </button>
                  <button
                    className="nav-link"
                    id="weekTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#weekTab"
                    type="button"
                    role="tab"
                    aria-controls="weekTab"
                    aria-selected="false"
                  >
                    Car Loan
                  </button>
                </div>
              </nav>
              <div className="range-label mt-40">Loan Term</div>
              <nav>
                <div
                  className="nav nav-tabs loan-type-select"
                  id="nav-tab"
                  role="tablist"
                >
                  <button
                    className="nav-link active"
                    id="yearTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#yearTab"
                    type="button"
                    role="tab"
                    aria-controls="yearTab"
                    aria-selected="false"
                  >
                    Yearly
                  </button>
                  <button
                    className="nav-link "
                    id="monthTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#monthTab"
                    type="button"
                    role="tab"
                    aria-controls="monthTab"
                    aria-selected="false"
                  >
                    Monthly
                  </button>
                  <button
                    className="nav-link"
                    id="weekTab-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#weekTab"
                    type="button"
                    role="tab"
                    aria-controls="weekTab"
                    aria-selected="false"
                  >
                    Weekly
                  </button>
                </div>
              </nav>
              <div className="range-label">Loan Amount</div>
              <div className="single-range">
                <div id="RangeSlider" />
                <div className="input-group">
                  <input className="noTextMerge" type="text" id="SetRange" />
                  <span className="input-group-text">₹  </span>
                </div>
              </div>
              <div className="range-label">Interest Rate</div>
              <div className="single-range">
                <div id="RoiRangeSlider" />
                <div className="input-group">
                  <input type="text" id="SetRoiRange" />
                  <span className="input-group-text">%</span>
                </div>
              </div>
              <div className="range-label">Loan Duration</div>
              <div className="single-range">
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="yearTab"
                    role="tabpanel"
                    aria-labelledby="yearTab"
                  >
                    <div id="YearRangeSlider" />
                  </div>
                  <div
                    className="tab-pane fade "
                    id="monthTab"
                    role="tabpanel"
                    aria-labelledby="monthTab"
                  >
                    <div id="MonthRangeSlider" />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="weekTab"
                    role="tabpanel"
                    aria-labelledby="weekTab"
                  >
                    <div id="WeekRangeSlider" />
                  </div>
                </div>
                <div className="input-group">
                  <input className="noTextMerge" type="text" id="SetMonthRange" />
                  <span className="input-group-text loanTermIndicator">
                    @example.com
                  </span>
                </div>
              </div>
              <div className="d-flex loan-start-date">
                <div>
                  <div className="range-label">Start Date</div>
                  <div className="inp-container">
                    <input
                      type="text"
                      id="loanStartDate"
                      placeholder="Select Date"
                    />
                  </div>
                </div>
                <div>
                  <div className="range-label">End Date</div>
                  <div className="inp-container">
                    <input
                      type="text"
                      id="loanEndDate"
                      placeholder="Select Date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 pl-lg-35">
            <div
              className="calculator-result-widget wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="pie-wrapper mt-25" id="loan_graph_circle">
                <div className="label">
                  Total Amount
                  <h2 className="LoanTotalAmount" />
                </div>
                <div className="pie">
                  <div className="left-side half-circle" />
                  <div className="right-side half-circle" />
                </div>
                <div className="circle-border" />
              </div>
              <div className="graph-indicator">
                <div>
                  <span className="blue-dot" /> EMI Amount
                </div>
                <div>
                  <span className="orange-dot" /> Interest Payable
                </div>
              </div>
              <ul className="loan-calculation list-unstyled">
                <li>
                  <span className="label">EMI Amount (Principal + Interest)</span>
                  <span className="amount LoanTotalAmount" />
                </li>
                <li>
                  <span className="label">Interest Payable</span>
                  <span className="amount" id="InterestPayable" />
                </li>
                <li>
                  <span className="label">Loan Duration</span>
                  <span className="amount LoanTotalDuration" />
                </li>
                <li>
                  <span className="label">Your EMI Amount</span>
                  <span className="amount" id="emiAmount" />
                </li>
              </ul>
              <a
                href="personal-details.html"
                className="theme-btn theme-btn-lg mt-20 w-100"
              >
                Apply Now
                <i className="arrow_right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  

  )
}
